function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useEffect } from 'react';
import { DropdownContext, useDropdownContext } from './context';
import { useAccessibleDropdown } from './useAccessibleDropdown';
import { getIndexedDropdownItems, getMaxHighlightIndex } from './utils';
import cn from 'classnames';
export var Dropdown = function Dropdown(props) {
  var _props$itemToggle;

  var dropdownRef = useRef(null);
  var menuRef = useRef(null);

  var _useState = useState(props.open || false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      highlightIndex = _useState4[0],
      setHighlightIndex = _useState4[1]; // -1 indicates no highlighted item


  var allItems = getIndexedDropdownItems(props.children);
  var maxHighlightIndex = getMaxHighlightIndex(props.children);

  var toggle = function toggle() {
    return setOpen(!open);
  };

  useEffect(function () {
    var _props$setOpen;

    (_props$setOpen = props.setOpen) === null || _props$setOpen === void 0 ? void 0 : _props$setOpen.call(props, open);
  }, [open]);
  var contextValue = {
    open: props.open ? props.open : open,
    toggle: props.toggle ? props.toggle : toggle,
    itemToggle: (_props$itemToggle = props.itemToggle) !== null && _props$itemToggle !== void 0 ? _props$itemToggle : true,
    setMenuOpen: setOpen,
    menuRef: menuRef,
    dropdownRef: dropdownRef,
    highlightIndex: highlightIndex,
    setHighlightIndex: setHighlightIndex,
    maxHighlightIndex: maxHighlightIndex,
    allItems: allItems
  };
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(InnerDropdown, {
    fullWidth: props.fullWidth,
    className: props.className
  }, props.children));
};

var InnerDropdown = function InnerDropdown(props) {
  var _useDropdownContext = useDropdownContext(),
      dropdownRef = _useDropdownContext.dropdownRef;

  useAccessibleDropdown();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('telia-dropdown', {
      'telia-dropdown--fullWidth': props.fullWidth
    }, props.className),
    ref: dropdownRef
  }, props.children);
};